﻿/*****
 Author:	    CT Software Systems, LLC
 Last Modified: 260125
 
 This script has utility functions to assist in editing questions.  Making them bold, italic,
 etc.  The WYSIWYG editor makes use of the HTML5 contenteditable property.

*/

// Global variables for toolbar

'use strict';

import {
    setModified
} from './ctssVal.js';



// This function was found by googling on internet - several reponses used it - not sure who original author is
const CreateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
const getGuidID = () => { /* hack for some browsers that cannot find id starting with a digit */
    return `a_${CreateUUID()}`;
}

/* private variables and functions */

let activeBtnClass;
let btnBoldId;
let btnItalicId;
let btnUnderlineId;
let btnHyperlinkId;
let btnAlignLeftId;
let btnAlignCenterId;
let btnAlignRightId;
let isBold = false;
let isItalic = false;
let isUnderline = false;
let isAlignLeft = true;
let isAlignCenter = false;
let isAlignRight = false;
let selectedTextObj = {};
let useBold;
let useItalic;
let useUnderline;
let useHyperlinks;
let useAlignment;

const appendLeafNode = (params) => {
    if (params.node.hasChildNodes()) {
        appendLeafNode({ node: params.node.childNodes[0], children: params.children });
    } else {
        for (let i = 0; i < params.children.length; i++) { params.node.appendChild(params.children[i]) }
    }
    return params.node;
}

const appendRangeNode = (params) => {
    params.range.insertNode(params.node);
    params.range.setStartAfter(params.node);
}

const consolidateSameColorSpans = (params) => {
    let html = params.html,
        searchValue = '</span><span style="color: #',
        iSiblingPos = html.indexOf(searchValue);

    while (iSiblingPos > -1) {
        let iNextOffSet = iSiblingPos + searchValue.length,
            iNextTextStartPos = html.indexOf('>', iNextOffSet) + 1,
            iNextTextEndPos = html.indexOf('<', iNextOffSet),
            nextColor = html.substr(iNextOffSet, 6),
            nextText = html.substring(iNextTextStartPos, iNextTextEndPos),
            iPrevTextStartPos = html.lastIndexOf(';">', iSiblingPos) + 3,
            iPrevTextEndPos = iSiblingPos,
            prevText = html.substring(iPrevTextStartPos, iPrevTextEndPos),
            prevColor = html.substr(iPrevTextStartPos - 9, 6);
        if (prevColor === nextColor) {
            let iStartPrevSpan = html.lastIndexOf('<span', iSiblingPos),
                iEndNextSpan = html.indexOf('</span>', iNextOffSet);
            html = html.substring(0, iStartPrevSpan) +
                `<span style="color: #${nextColor};">${prevText}${nextText}</span>` +
                html.substring(iEndNextSpan + 7);
            iNextOffSet = 0; /* Restart search at beginning since html was altered */
        }
        iSiblingPos = html.indexOf(searchValue, iNextOffSet);
    }
    return html;
}

const consolidateTextNodes = () => {
    getSelection().anchorNode.parentNode.normalize();
}

const createNode = (params) => {
    const tagName = params.tagName === undefined ? 'span' : params.tagName;
    const e = document.createElement(tagName);
    if (params.childNode !== undefined) {
        e.innerHTML = params.childNode.nodeType === 3
            ? params.childNode.nodeValue : params.childNode.nodeType === 1
                ? params.childNode.outerHTML : 'Invalid Node Type';
    } else if (params.innerHTML !== undefined) {
        e.innerHTML = params.innerHTML;
    } else if (params.textContent !== undefined || params.node !== undefined) {
        let innerText = '';
        if (params.textContent !== undefined) {
            innerText += params.textContent;
        } else {
            for (let i = 0; i < params.node.childNodes.length; i++) {
                innerText += params.node.childNodes[i].textContent
            }
        }
        e.innerText = innerText;
    }
    if (tagName.toLowerCase() === 'span') {
        const color = params.color === undefined ? '' : `color: ${params.color};`;
        e.setAttribute('style', color);
    }
    return e;
}

const createTreeAndGetLeafNode = (params) => {
    let isUnderlined = false;
    let tree;
    let node = params.node;
    while (node.nodeType !== 3) {
        if ('IBU'.indexOf(node.nodeName) > -1) { /* at most three node will be created */
            if (node.nodeName === 'U') {
                isUnderlined = true;
            }
            tree = (tree === undefined)
                ? createNode({ tagName: node.nodeName.toLowerCase() })
                : appendLeafNode({ node: tree, children: [createNode({ tagName: node.nodeName.toLowerCase() })] });
        }
        node = node.childNodes[0];
    }
    return { tree: tree, leafNode: node, isUnderlined: isUnderlined, textContent: node.textContent }
}

const createColorSpanHTML = (params) =>
    `<span style="color: ${params.color}";>${params.textContent}</span>`;

const getHTML = (params) =>
    params.node.nodeType === 1
        ? params.node.outerHTML : params.node.nodeType === 3
            ? params.node.textContent : '';

const getNodeStyleAttribute = (params) => {
    let value = '';
    const l = params.node.attributes === undefined ? 0 : params.node.attributes.length;
    if (l > 0) {
        for (let i = 0; i < l; i++) {
            if (params.node.attributes[i].name === 'style') {
                const styles = params.node.attributes[i].nodeValue.split(';');
                for (let j = 0; j < styles.length; j++) {
                    const nameValue = styles[j].split(':');
                    if (nameValue[0] === params.attrNm) {
                        value = nameValue[1];
                    }
                }
            }
        }
    }
    return value;
}

const getNodeForSelectedTextContainer = (params) => {
    if (params.containerNm !== undefined) {
        console.log(params.containerNm, params.container);
    }
    let node = params.node;
    while ('IBUSPAN'.indexOf(node.parentNode.nodeName) > -1) {
        node = node.parentNode;
    }
    return node;
}

const getSpanOrTextNodeFromParent = (params) => {
    let node = params.node;
    while ('BIU'.indexOf(node.nodeName) > -1) {
        node = node.childNodes[0];
    };
    return node;
}

const getTextFormatting = (params) => {
    let isBold = false,
        isItalic = false,
        isUnderlined = false,
        node = params.node;
    if (params.traverseBaseToParent !== undefined && params.traverseBaseToParent === true) {
        while (node.nodeName !== 'DIV') {
            if (node.nodeName === 'B') {
                isBold = true;
            } else if (node.nodeName === 'I') {
                isItalic = true;
            } else if (node.nodeName === 'U') {
                isUnderlined = true;
            }
            node = node.parentNode;
        }
    } else {
        while (node.nodeName !== 'SPAN' && node.nodeName != '#text') {
            if (node.nodeName === 'B') {
                isBold = true;
            } else if (node.nodeName === 'I') {
                isItalic = true;
            } else if (node.nodeName === 'U') {
                isUnderlined = true;
            }
            node = node.childNodes[0];
        }
    }
    return { isBold, isItalic, isUnderlined }
}

const getTextNode = (params) => {
    let node = params.node;
    if (node.childNodes.length > 0) {
        while (node.nodeName !== '#text') {
            node = node.childNodes[0];
        }
    }
    return node;
}

const getTreeOrLeafNode = (params) =>
    (params.tree === undefined)
        ? params.children
        : [appendLeafNode({ node: params.tree, children: params.children })];

const isTextUnderlined = (params) => {
    let node = params.node;
    while (node.nodeName !== 'DIV') {
        if (node.nodeName === 'U') {
            return true
        }
        node = node.parentNode;
    }
    return false;
}

const removeParentFormatFromNode = (params) => {
    let node = params.node,
        tagName = params.tagName.toUpperCase();

    if (params.traverseBaseToParent !== undefined) {
        while (node.nodeName !== tagName) {
            node = node.parentNode;
            if (node.parentName === tagName) { // nested format tags i.e <b><b>
                node = node.parentNode;
            }
        }
    } else {
        while (node.nodeName !== tagName) {
            node = node.childNodes[0];
            if (node.parentName === tagName) { // nested format tags i.e <b><b>
                node = node.childNodes[0];
            }
        }
    }
    node.replaceWith(node.childNodes[0]);
}

const setColorForSpan = (params) => {
    const oldStyles = params.span.attributes[0].nodeValue.split(';');
    let newStyles = '';
    for (let i = 0; i < oldStyles.length; i++) {
        if (oldStyles[i].indexOf('color') === 0) {
            newStyles += params.color !== undefined ? `color: ${params.color};` : `${oldStyles[i]};`;
        } else if (oldStyles[i].indexOf('background-color') > 0) {
            newStyles += params.bgColor !== undefined ? `background-color: ${params.bgColor};` : `${oldStyles[i]};`;
        }
    }
    params.span.attributes[0].nodeValue = newStyles;
}

const clearColorForCurrentNode = (params) => {
    //console.log('clearCurrent', params.node);
    if (params.node.parentNode === null || params.node.parentNode.nodeName !== 'SPAN') {
        return;
    }
    let isUnderlined = isTextUnderlined({ node: params.node }),
        s = params.node.textContent;

    if (isUnderlined || params.startOffset === 0 && params.endOffset === s.length) {
        removeColorSpan({ node: params.node });
    } else {
        const color = getNodeStyleAttribute({ node: params.node.parentNode, attrNm: 'color' });
        let parentOuterHTML = '';

        if (params.startOffset > 0) {
            parentOuterHTML += createColorSpanHTML({ color: color, textContent: s.substring(0, params.startOffset) });
        }
        parentOuterHTML += s.substr(params.startOffset, params.endOffset - 1);
        if (params.endOffset < s.length) {
            parentOuterHTML += createColorSpanHTML({ color: color, textContent: s.substring(params.endOffset) });
        }
        params.node.parentNode.outerHTML = parentOuterHTML;
    }
}

const clearColorForEndNode = (params) => {

    /* node = text node where user selection started
     * offset = position within node where user selection started */

    //console.log('clearEnd', params.node);
    //console.log('clearEnd parans', params);

    const treeObj = createTreeAndGetLeafNode({ node: params.node });
    const tree = treeObj.tree,
        isUnderlined = treeObj.isUnderlined,
        idx = params.offset,
        s = treeObj.textContent;
    let node = params.node;

    //console.log('clear end treeObj', treeObj);

    if (isUnderlined || idx === 0 || idx === s.length) {
        //console.log('end a');
        return getTreeOrLeafNode({ tree: tree, children: [document.createTextNode(s)] });
    } else {
        //console.log('end b');
        const clearNode = document.createTextNode(s.substr(0, idx));
        if (node.nodeName === 'SPAN') {
            node.textContent = s.substr(idx);
        } else {
            node = document.createTextNode(s.substr(idx));
        }
        return getTreeOrLeafNode({ tree: tree, children: [clearNode, node] });
    }
}

const clearColorForSibling = (params) => {

    //console.log('clearSibling',params.node)
    //console.log('clearSilings params', params);

    const treeObj = createTreeAndGetLeafNode({ node: params.node });
    const tree = treeObj.tree,
        node = treeObj.leafNode;

    //console.log('clearSilings treeObj', treeObj);
    return getTreeOrLeafNode({ tree: tree, children: [node] });
}

const clearColorForStartNode = (params) => {
    /* node = text node where user selection started
     * offset = position within node where user selection started */

    //console.log('clearStart', params.node);
    //console.log('clearStart parans', params);

    const treeObj = createTreeAndGetLeafNode({ node: params.node });
    const tree = treeObj.tree,
        isUnderlined = treeObj.isUnderlined,
        idx = params.offset,
        node = params.node,
        s = treeObj.textContent;

    //console.log('clear start treeObj', treeObj);

    if (isUnderlined || idx === 0 || idx === s.length) {
        //console.log('start a');
        return getTreeOrLeafNode({ tree: tree, children: [document.createTextNode(s)] });
    } else {
        //console.log('start b');
        node.textContent = s.substr(0, idx);
        const clearNode = document.createTextNode(s.substr(idx));
        return getTreeOrLeafNode({ tree: tree, children: [node, clearNode] });
    }
}

const clearSelectedColor = () => {
    if (selectedTextObj.selectedText.length > 0) {
        setModified(true);
        if (selectedTextObj.range.commonAncestorContainer.childNodes.length === 0) {
            clearColorForCurrentNode({
                node: selectedTextObj.range.commonAncestorContainer,
                startOffset: selectedTextObj.range.startOffset,
                endOffset: selectedTextObj.range.endOffset
            });
        } else {
            const startNode = getNodeForSelectedTextContainer({
                container: selectedTextObj.range.startContainer,
                //containerNm: 'clear startContainer',
                node: selectedTextObj.range.startContainer
            });
            const endNode = getNodeForSelectedTextContainer({
                container: selectedTextObj.range.endContainer,
                //containerNm: 'clear endContainer',
                node: selectedTextObj.range.endContainer
            });

            //console.log('clear selectedTextObj', selectedTextObj);
            //console.log('starting node', startNode);
            //console.log('ending node', endNode);

            let beforeStart = true, afterEnd = false, html = '';
            for (let i = 0; i < selectedTextObj.range.commonAncestorContainer.childNodes.length; i++) {
                let node = selectedTextObj.range.commonAncestorContainer.childNodes[i];
                if (startNode === node) {
                    beforeStart = false;
                    //console.log('start', node);
                    clearColorForStartNode({
                        node: node,
                        offset: selectedTextObj.range.startOffset
                    }).forEach(retNode => html += getHTML({ node: retNode }));
                    //}).forEach(node => { console.log('startNode', node); html += getHTML({ node: node });});
                } else if (endNode === node) {
                    afterEnd = true;
                    //console.log('end', node);
                    clearColorForEndNode({
                        node: node,
                        offset: selectedTextObj.range.endOffset
                    }).forEach(node => html += getHTML({ node: node }));
                } else if (beforeStart || afterEnd) {
                    html += getHTML({ node: node })
                } else {
                    clearColorForSibling({ node: node }).forEach(node => html += getHTML({ node: node }));
                    //let s = getHTML({ node: clearColorForSibling({ node: node }) });
                    //console.log('sibling retnode ' + s);
                    //html += getHTML({ node: clearColorForSibling({ node: node }) });
                }
            };
            selectedTextObj.range.commonAncestorContainer.innerHTML = consolidateSameColorSpans({ html: html });
        }
    }
}

const removeColorSpan = (params) => {
    let node = params.node;
    if (node.nodeType === 3) {
        if (node.parentNode !== null && node.parentNode.nodeName === 'SPAN') {
            node.parentNode.outerHTML = node.parentNode.outerHTML.replace(/<\/?span[a-zA-Z0-9 =:"#;]*>/gi, '');
        }
    } else {
        while (node.childNodes.length > 0) {
            if (node.nodeName === 'SPAN') {
                node.outerHTML = node.outerHTML.replace(/<\/?span[a-zA-Z0-9 =:"#;]*>/gi, '');
                break;
            }
            node = childNodes[0];
        }
    }
}

const setColorEndNode = (params) => {

    /* color = optional when span is created
        * node = text node where user selection started
        * offset = position within node where user selection started
        * tagName = B, I, U, or span */

    //console.log('setColorEndNode node', params.node)
    const newSpan = createNode({ color: params.color });

    const treeObj = createTreeAndGetLeafNode({ node: params.node });
    const tree = treeObj.tree;
    const node = treeObj.leafNode;
    const isUnderlined = treeObj.isUnderlined;

    const s = node.textContent;
    const idx = params.offset;
    if (isUnderlined || idx === 0 || idx === s.length) {
        newSpan.innerText = s;
        return getTreeOrLeafNode({ tree: tree, children: [newSpan] });
    } else {
        newSpan.innerText = s.substr(0, idx);
        node.textContent = s.substr(idx);
        return getTreeOrLeafNode({ tree: tree, children: [newSpan, node] });
    }
};

const setColorSibling = (params) => {
    if ('BIU'.indexOf(params.node.nodeName) > -1) {
        setColorSibling({ color: params.color, node: params.node.childNodes[0] });
    } else if (params.node.childNodes.length > 1) {
        /* must combine all contigious text and span nodes */
        let innerText = '';
        let siblingNode = params.node.childNodes[0];
        while (siblingNode.nextSibling !== null) {
            let nextSibling = siblingNode.nextSibling;
            if ('SPAN#text'.indexOf(siblingNode.nodeName) > -1) {
                innerText += siblingNode.innerText;
                siblingNode.parentNode.removeChild(siblingNode);
            } else {
                const newSpan = createNode({ color: params.bgColor, textContent: innerText });
                siblingNode.parentNode.insertBefore(newSpan, siblingNode);
                setColorSibling({ color: params.color, node: siblingNode });
            }
            siblingNode = nextSibling;
        }
    } else if (params.node.nodeName === 'SPAN') {
        setColorForSpan({ color: params.color, span: params.node })
    } else if (params.node.nodeName === '#text') {
        const newNode = createNode({ color: params.color, textContent: params.node.textContent });
        if (params.node.parentNode === null) {
            params.node = newNode;
        } else if (params.node.parentNode.nodeName !== 'SPAN') {
            params.node.parentNode.replaceChild(newNode, params.node);
        };
    }
    return params.node;
}
const setColorStartNode = (params) => {

    /* color = optional when span is created
     * node = text node where user selection started
     * offset = position within node where user selection started
     * tagName = B, I, U, or span */

    const newSpan = createNode({ color: params.color })

    const treeObj = createTreeAndGetLeafNode({ node: params.node });
    const tree = treeObj.tree;
    const node = treeObj.leafNode;
    const isUnderlined = treeObj.isUnderlined;

    //console.log('setColorStartNode treeObj', treeObj)
    //console.log('setColorStartNode node', node);

    const s = node.textContent;
    const idx = params.offset;

    if (isUnderlined || idx === 0) {
        newSpan.innerText = s;
        return getTreeOrLeafNode({ tree: tree, children: [newSpan] });
    } else {
        node.textContent = s.substr(0, idx);
        const firstNode = node.parentNode !== null && node.parentNode.nodeName === 'SPAN'
            ? node.parentNode : node;
        newSpan.innerText = s.substr(idx);
        return getTreeOrLeafNode({ tree: tree, children: [firstNode, newSpan] });
    }
}

//  /* This function is used to decodeHTML replacing the special characters

//    /&amp;/g is regular expression where
//    /&amp;/ means search for &amp; in string
//    g means globally replace all occurances with instead of just first
//    pattern is replaced with special XML characters so browser will interpreting html tags normally

//  */
//  const decodeHTML = (value) =>
//      value.replace(/&amp;/g, '&')
//          .replace(/&lt;/g, '<')
//          .replace(/&gt;/g, '>')
//          .replace(/&quot;/g, '"')
//          .replace(/&apos;/g, "'");

//  /* This function is used to encodeHTML with special characters

//      /&/g is regular expression where
//      /&/ means search for & in string
//      g means globally replace all occurances instead of just first
//      pattern is replaced with escaped XM characters so browser displays them instead of interpreting them

//  */
//  const encodeHTML = (value) =>
//      value.replace(/&/g, '&amp;')
//          .replace(/</g, '&lt;')
//          .replace(/>/g, '&gt;')
//          .replace(/"/g, '&quot;')
//          .replace(/'/g, '&apos;');

const getHexFromRGBString = (rgb) => {
    /* converts rgb in string format ie. rbg(255,255,255) to hex value */

    const delimiter = rgb.indexOf(",") > -1 ? "," : " ";
    // Turn "rgb(r,g,b)" into [r,g,b]
    rgb = rgb.substr(4).split(")")[0].split(delimiter);

    /* Convert values from decimal to hexidecimal using toString(16) */

    let r = (+rgb[0]).toString(16),
        g = (+rgb[1]).toString(16),
        b = (+rgb[2]).toString(16);

    if (r.length === 1)
        r = "0" + r;
    if (g.length === 1)
        g = "0" + g;
    if (b.length === 1)
        b = "0" + b;

    return "#" + r + g + b;
}
const getSelectedTextObject = () => {
    const sel = getSelection();
    const range = sel.getRangeAt(0);
    const startNode = getNodeForSelectedTextContainer({
        container: range.startContainer,
        node: range.startContainer
    });
    const endNode = getNodeForSelectedTextContainer({
        container: range.endContainer,
        node: range.endContainer
    });
    return { selectedText: sel.toString(), range, startNode, endNode };
}

const getSelection = () =>
    window.getSelection
        ? window.getSelection() // >= 1E9 and non IE Browsers
        : document.selection(); // <= IE8

const isNodeBold = (params) =>
    (params.node.nodeName === 'STRONG' || params.node.nodeName === 'B');

const isNodeItalic = (params) =>
    (params.node.nodeName === 'EM' || params.node.nodeName === 'I');

const isNodeUnderline = (params) =>
    (params.node.nodeName === 'U');

const setSelectedText = (params) => {
    /* Reselected user selected text lost when window loses focus */
    const r = new Range();
    r.setStart(params.startContainer, params.startOffset);
    r.setEnd(params.endContainer, params.endOffset);
    const sel = getSelection();
    sel.removeAllRanges();
    sel.addRange(r);
}
const setBtnsForToolBar = () => {
    if (useBold)
        toggleActiveBtnStatus({ id: btnBoldId, isActive: isBold });
    if (useItalic)
        toggleActiveBtnStatus({ id: btnItalicId, isActive: isItalic });
    if (useUnderline)
        toggleActiveBtnStatus({ id: btnUnderlineId, isActive: isUnderline });
    if (useAlignment) {
        toggleAlignment();
    }
}
const setColorBtnIcon = () => {
    const sel = getSelection();
    let currentColor = '';
    let node = sel.isCollapsed ? sel.anchorNode : sel.focusNode;
    while (node !== null) {
        if (node.nodeName === 'SPAN') {
            currentColor = getNodeStyleAttribute({ node: node, attrNm: 'color' });
            break;
        }
        node = node.parentNode
    }
    $('.fa-tint').css('color', currentColor);
}
const setFlagsForToolBar = (params) => {
    if (params.node === undefined || params.node === null) {
        return;
    }
    // function is called several times when traversing the hierarchy so you cannot use isBold = (node.nodeName == 'STRONG')
    // because a child or parent params.node will change the setting of isBold
    if (params.node.nodeName === 'STRONG' || params.node.nodeName === 'B') {
        isBold = true;
        return;
    }
    if (params.node.nodeName === 'EM' || params.node.nodeName === 'I') {
        isItalic = true;
        return;
    }
    if (params.node.nodeName === 'U') {
        isUnderline = true;
        return;
    }
    if (useAlignment && (params.node.nodeName === 'DIV' || params.node.nodeName === 'P')) {
        isAlignLeft = false;
        isAlignCenter = false;
        isAlignRight = false;
        if (node.outerHTML.indexOf('align=\"center\"') > -1) {
            isAlignCenter = true;
        } else if (node.outerHTML.indexOf('align=\"right\"') > -1) {
            isAlignRight = true;
        } else {
            isAlignLeft = true;
        }
        return;
    }
}

const setSelectionAndCursor = () => {
    const sel = getSelection();
    const range = sel.getRangeAt(0);
    if (range.collapsed) {
        sel.removeAllRanges();
        sel.addRange(range);
    }
}

const toggleActiveBtnStatus = (params) =>
    params.isActive
        ? $(params.id).addClass(activeBtnClass)
        : $(params.id).removeClass(activeBtnClass);


const toggleAlignment = () => {
    toggleActiveBtnStatus({ id: btnAlignLeftId, isActive: isAlignLeft });
    toggleActiveBtnStatus({ id: btnAlignCenterId, isActive: isAlignCenter });
    toggleActiveBtnStatus({ id: btnAlignRightId, isActive: isAlignRight });
}

const buildColorPickerDlg = (params) => {
    let content = '';
    for (let i = 0; i < params.pallette.length; i++) {
        content += '<div>';
        for (let j = 0; j < params.pallette[0].length; j++) {
            content += `<div class="colorCircle ib" style = "background-color: ${params.pallette[i][j]};" ></div >`;
        }
        content += '</div>';
    }
    content += '<div>Custom color: <input id="hexColor" type="color"></div>'
    content += '<div class="mTop5">' +
        '<button id="btnPickColor" class="btn btn-sm">OK</button>' +
        '<button id = "btnCancelColor" class="btn btn-sm mLeft5">Cancel</button>' +
        '<button id="btnClearColor" class="btn btn-sm mLeft5">Clear</button></div>';
    $(params.dlgId).empty().append(content);
}

const initColorPickerDlg = (params) => {
    const pallette =
        [
            /* red, pink, orange, yellow, blue, green */
            ['#FF0000', '#FF00EA', '#FFA500', '#FFFF00', '#0084FF', '#00FF1E']
        ];
    buildColorPickerDlg({ dlgId: params.dlgId, pallette: pallette });
}

//  /* public variables and functions */

const boldOnClick = (params) => {
    setSelectionAndCursor();
    document.execCommand('bold');
    isBold = !isBold;
    toggleActiveBtnStatus({ id: btnBoldId, isActive: isBold });
    consolidateTextNodes();
};

const bgColorOnClick = (params) => alert('not implemented ');

const colorOnClick = (params) => {

    if (selectedTextObj.selectedText.length > 0) {
        setModified(true);
        const r = new Range();
        if (selectedTextObj.range.commonAncestorContainer.childNodes.length === 0) {
            //console.log('selectedTextObj', selectedTextObj);

            const isUnderlined = isTextUnderlined({ node: selectedTextObj.range.commonAncestorContainer });
            const s = selectedTextObj.range.commonAncestorContainer.textContent;

            r.selectNode(selectedTextObj.range.commonAncestorContainer);
            r.deleteContents();

            //              console.log('selectedTextObj after change', selectedTextObj);
            if (isUnderlined) {
                appendRangeNode({ range: r, node: createNode({ color: params.color, textContent: s }) })
            } else {
                const idx = s.indexOf(selectedTextObj.selectedText);
                appendRangeNode({ range: r, node: document.createTextNode(s.substr(0, idx)) })
                appendRangeNode({ range: r, node: createNode({ color: params.color, textContent: selectedTextObj.selectedText }) })
                appendRangeNode({ range: r, node: document.createTextNode(s.substr(idx + selectedTextObj.selectedText.length)) })
            }
        } else {
            const startNode = getNodeForSelectedTextContainer({
                container: selectedTextObj.range.startContainer,
                //containerNm: 'startContainer',
                node: selectedTextObj.range.startContainer
            });
            const endNode = getNodeForSelectedTextContainer({
                container: selectedTextObj.range.endContainer,
                containerNm: 'endContainer',
                node: selectedTextObj.range.endContainer
            });

            //console.log('selectedTextObj', selectedTextObj);
            //console.log('starting node', startNode);
            //console.log('ending node', endNode);

            let html = '';
            let beforeStart = true, afterEnd = false;
            for (let i = 0; i < selectedTextObj.range.commonAncestorContainer.childNodes.length; i++) {
                const node = selectedTextObj.range.commonAncestorContainer.childNodes[i];
                if (startNode === node) {
                    beforeStart = false;
                    //console.log('start', node);
                    const startNodes = setColorStartNode({
                        bgColor: params.bgColor,
                        color: params.color,
                        node: node.cloneNode(true),
                        offset: selectedTextObj.range.startOffset
                    });
                    for (let j = 0; j < startNodes.length; j++) {
                        html += getHTML({ node: startNodes[j] })
                    }
                    //console.log('startnodes', startNodes);

                } else if (endNode === node) {
                    afterEnd = true;
                    //console.log('end', node);
                    const endNodes = setColorEndNode({
                        bgColor: params.bgColor,
                        color: params.color,
                        node: node.cloneNode(true),
                        offset: selectedTextObj.range.endOffset
                    });
                    for (let j = 0; j < endNodes.length; j++) {
                        html += getHTML({ node: endNodes[j] })
                    }
                    //console.log('endNodes', endNodes);

                } else if (beforeStart || afterEnd) {
                    html += getHTML({ node: node })
                } else {
                    //console.log('next sibling', node);
                    //let retNode = setColorSibling({ bgColor: params.bgColor, color: params.color, node: node.cloneNode(true) });
                    //console.log('return node', retNode);
                    //html += getHTML({ node: retNode })
                    html += getHTML({ node: setColorSibling({ bgColor: params.bgColor, color: params.color, node: node.cloneNode(true) }) })
                }
            }
            //console.log('html', html);
            //let newHtml = consolidateSameColorSpans({ html: html });
            //console.log(' html', newHtml); 

            selectedTextObj.range.commonAncestorContainer.innerHTML = consolidateSameColorSpans({ html: html });

        }
    }
};

const convertATagsToSpans = (params) => {
    /* converts <a href="xx">zzz</a> to
     * <span id="link_0" contenteditable="false" data-href="xx" data-linktext="zzz" data-target="#hyperlinkDlg" data-toggle="modal">zzz <i class="fa fa-link"></i></span> */

    if (params.arr === undefined || params.fldNm === undefined) {
        alert('arr, fldNm are required parameters...');
        return;
    }

    params.arr.forEach(row => {
        let hasConversion = false;
        const div = document.createElement('div');
        div.innerHTML = row[params.fldNm];
        const aTags = div.querySelectorAll('a');
        aTags.forEach(aTag => {
            const span = document.createElement('span');
            span.id = aTag.id;
            span.contentEditable = "false";
            span.setAttribute('data-href', aTag.getAttribute('href'));
            span.setAttribute('data-linktext', aTag.innerHTML);
            span.setAttribute('data-target', '#hyperlinkDlg');
            span.setAttribute('data-toggle', 'modal');
            span.innerHTML = `${aTag.innerHTML} <i class="fa fa-link">`;
            const a = div.querySelector(`#${aTag.id}`);
            div.replaceChild(span, a);
            hasConversion = true;
        });
        if (hasConversion) {
            row[params.fldNm] = div.innerHTML;
        }
    });
}

const convertSpansToATags = (params) => {
    if (params.arr === undefined || params.fldNm === undefined) {
        alert('arr, fldNm are required parameters...');
        return;
    }
    params.arr.forEach(row => {
        let hasConversion = false;
        const div = document.createElement('div');
        div.innerHTML = row[params.fldNm];
        const spanLinks = div.querySelectorAll('span[data-href]');
        spanLinks.forEach(spanLink => {
            const a = document.createElement('a');
            a.id = spanLink.id;
            a.setAttribute('href', spanLink.getAttribute('data-href'));
            a.innerHTML = spanLink.getAttribute('data-linktext');
            const span = div.querySelector(`#${spanLink.id}`);
            div.replaceChild(a, span);
            hasConversion = true;
        });
        if (hasConversion) {
            row[params.fldNm] = div.innerHTML;
        }
    });
}

const init_ctssEditor = (params = {}) => {
    const {
        activeBtnClass = '',
        btnBoldId = '#btnBold',
        btnItalicId = '#btnItalic',
        btnUnderlineId = '#btnUnderline',
        btnHyperlinkId = '#btnHyperlink',
        btnAlignLeftId = '#btnAlignLeft',
        btnAlignCenterId = '#btnAlignCenter',
        btnAlignRightId = '#btnAlignRight',
        useBold = true,
        useItalic = true,
        useUnderline = true,
        useHyperlinks = false,
        useAlignment = false,
        useColorPicker,
        btnColorId = '#btnColor',
        colorPickerDlgId = '#colorPicker'
    } = params; 


    if (useHyperlinks) {

        const createHyperlinkSpan = (params) => {
            const span = document.createElement('span');
            span.id = getGuidID();
            span.contentEditable = "false";
            span.setAttribute('title', 'Click to edit text or remove link...')
            span.setAttribute('data-href', params.href);
            span.setAttribute('data-linktext', params.linkText);
            span.setAttribute('data-target', '#hyperlinkDlg');
            span.setAttribute('data-toggle', 'modal');
            span.innerHTML = `${params.linkText} <i class="fa fa-link">`;
            return span;
        }
        const parentNodesHaveFormatOrColor = (params) => {
            let hasFormatOrColor = false,
                hasUnderline = false,
                node = params.node;
            while (node.nodeName !== 'DIV') {
                hasFormatOrColor = hasFormatOrColor ||
                    isNodeBold({ node: node }) ||
                    isNodeItalic({ node: node }) ||
                    (node.nodeName === 'SPAN' && getNodeStyleAttribute({ node: node, attrNm: 'color' }).length > 0);
                hasUnderline = hasUnderline || isNodeUnderline({ node: node });

                node = node.parentNode;
            }
            return { hasFormatOrColor, hasUnderline };
        }
        const nodesHaveFormatOrColor = () => {

            let hasFormatOrColor = false,
                hasUnderline = false,
                sel = getSelectedTextObject();

            const childNodes = sel.range.commonAncestorContainer.childNodes;
            const totalChildNodes = childNodes.length;

            //console.log('hasFormatOrColor', sel);
            if (totalChildNodes === 0) {
                const retval = parentNodesHaveFormatOrColor({ node: sel.range.commonAncestorContainer });
                hasFormatOrColor = retval.hasFormatOrColor;
                hasUnderline = retval.hasUnderline;
            } else {
                const startNode = getNodeForSelectedTextContainer({
                    container: selectedTextObj.range.startContainer,
                    //containerNm: 'startContainer',
                    node: selectedTextObj.range.startContainer
                });
                const endNode = getNodeForSelectedTextContainer({
                    container: selectedTextObj.range.endContainer,
                    //containerNm: 'endContainer',
                    node: selectedTextObj.range.endContainer
                });
                let selectedNodes = false;
                for (let i = 0; i < totalChildNodes; i++) {
                    if (childNodes[i] === startNode) {
                        selectedNodes = true;
                    }
                    if (selectedNodes) {
                        const retval = parentNodesHaveFormatOrColor({ node: childNodes[i] });
                        hasFormatOrColor = hasFormatOrColor || retval.hasFormatOrColor;
                        hasUnderline = hasUnderline || retval.hasUnderline;
                        if (childNodes[i] === endNode) {
                            selectedNodes = false;
                        }
                    }
                }
            }
            return { hasFormatOrColor, hasUnderline };
        };

        const setHyperlinkEndNode = (params) => {

            //console.log('end node', params.node);
            //console.log('end node parent', params.node.parentNode);
            //console.log('end offset', params.offset);

            const idx = params.offset,
                node = params.node;

            if (idx === node.textContent.length) {
                node.parentNode.removeChild(node);
            } else {
                const s = node.textContent;
                node.textContent = s.substr(idx)
            }

        }
        const setHyperlinkStartNode = (params) => {

            //console.log('start node', params.node);
            //console.log('start node parent', params.node.parentNode);
            //console.log('start offset', params.offset);
            //console.log('href', params.href);
            //console.log('linkText', params.linkText);
            //console.log('endNode', params.endNode);

            const href = params.href,
                idx = params.offset,
                linkText = params.linkText;
            let node = params.node;

            const span = createHyperlinkSpan({ href: href, linkText: linkText });

            if (idx === 0) {
                node.replaceWith(span);
            } else {
                getTextNode({ node: node }).textContent = node.textContent.substr(0, idx);
                node.parentNode.insertBefore(span, node.nextSibling);
            }
            while (span.nextSibling !== params.endNode) {
                span.parentNode.removeChild(span.nextSibling);
            }
        }

        $('#hyperlinkDlg').on('show.bs.modal', (e) => {
            $('#divHyperlinkDlgErrMsg,#cleanTextAlert').addClass('hidden');
            $('#editLinkText,#editHyperlink').removeAttr('disabled');
            if (e.relatedTarget.dataset.href !== undefined) {
                $('#hiddenLinkId').val(e.relatedTarget.id);
                $('#btnRemoveHyperlink').removeAttr('disabled');
                $('#editHyperlink').val(e.relatedTarget.dataset.href);
                $('#editLinkText').val(e.relatedTarget.dataset.linktext);
            } else {
                selectedTextObj = getSelectedTextObject();
                if (selectedTextObj.selectedText.length > 0) {
                    const selectedTextInfo = nodesHaveFormatOrColor();
                    if (selectedTextInfo.hasUnderline) {
                        $('#divHyperlinkDlgErrMsg').text('A fill in the blank cannot be part of the hyperlink!').removeClass('hidden');
                        $('#editLinkText,#editHyperlink,#btnSaveHyperlink').prop('disabled', true);
                    } else if (selectedTextInfo.hasFormatOrColor) {
                        $('#cleanTextAlert').removeClass('hidden');
                    }
                    $('#hiddenLinkId').val('');
                    $('#editLinkText').val(selectedTextObj.selectedText);
                    $('#btnRemoveHyperlink').prop('disabled', true);
                }

            }
        });
        $('#editHyperlink,#editLinkText').on('keyup', () => {
            if ($('#editHyperlink').val().length > 0 && $('#editLinkText').val().length > 0) {
                $('#btnSaveHyperlink').removeAttr('disabled');
            } else {
                $('#btnSaveHyperlink').prop('disabled', true);
            }
        });
        $('#btnRemoveHyperlink').on('click', () => {
            const targetLink = document.getElementById($('#hiddenLinkId').val());
            const nextSibling = targetLink.nextSibling,
                prevSibling = targetLink.previousSibling;
            let s = '';
            if (prevSibling.nodeType === 3) {
                s += prevSibling.textContent;
                targetLink.parentNode.removeChild(prevSibling);
            }
            s += targetLink.innerText.substr(0, targetLink.innerText.length - 1);
            if (nextSibling.nodeType === 3) {
                s += nextSibling.textContent;
                targetLink.parentNode.removeChild(nextSibling);
            }
            targetLink.replaceWith(document.createTextNode(s));
            $('#hiddenLinkId').val('');
            $('#hyperlinkDlg').modal('hide');
        });
        $('#btnSaveHyperlink').on('click', () => {
            let href = $('#editHyperlink').val();
            const id = $('#hiddenLinkId').val(),
                linkText = $('#editLinkText').val();

            //console.log(`save hyperlink id ${id} href ${href} text ${linkText}`);

            if (href.indexOf('http') === -1) {
                href = `https://${href}`;
            }

            if (id.length > 0) { /* Edit existing hyperlink */

                const span = document.getElementById(id);
                span.setAttribute('data-href', href);
                span.setAttribute('data-linktext', linkText);
                span.innerHTML = `${linkText} <i class="fa fa-link">`;

            } else { /* Create hyperlink */

                const r = new Range();

                if (selectedTextObj.range.commonAncestorContainer.nodeType === 3) { /* text node */

                    const s = selectedTextObj.range.commonAncestorContainer.textContent,
                        idx = s.indexOf(selectedTextObj.selectedText);

                    r.selectNode(selectedTextObj.range.commonAncestorContainer);
                    r.deleteContents();

                    if (idx > 0) {
                        appendRangeNode({ range: r, node: document.createTextNode(s.substr(0, idx)) })
                    }
                    //appendRangeNode({ range: r, node: span });
                    appendRangeNode({ range: r, node: createHyperlinkSpan({ href: href, linkText: linkText }) });
                    if (idx + selectedTextObj.selectedText.length < s.length) {
                        appendRangeNode({ range: r, node: document.createTextNode(s.substr(idx + selectedTextObj.selectedText.length)) })
                    }
                }
                else {

                    const startNode = getNodeForSelectedTextContainer({
                        container: selectedTextObj.range.startContainer,
                        //containerNm: 'startContainer',
                        node: selectedTextObj.range.startContainer
                    });
                    const endNode = getNodeForSelectedTextContainer({
                        container: selectedTextObj.range.endContainer,
                        //containerNm: 'endContainer',
                        node: selectedTextObj.range.endContainer
                    });
                    setHyperlinkStartNode({
                        href: href,
                        linkText: linkText,
                        node: startNode,
                        offset: selectedTextObj.range.startOffset,
                        endNode: endNode
                    });
                    setHyperlinkEndNode({
                        node: endNode,
                        offset: selectedTextObj.range.endOffset
                    });
                }
            }
            $('#hyperlinkDlg').modal('hide');
        });
    }

    if (useColorPicker) {
        initColorPickerDlg({ dlgId: colorPickerDlgId });
        $(btnColorId).on('click', () => {
            selectedTextObj = getSelectedTextObject();
            $(colorPickerDlgId).removeClass('hidden');
        });
        $(colorPickerDlgId + '>div>div').on('click', function () {
            $('#hexColor').val(getHexFromRGBString($(this).css('background-color')));
            setSelectedText({
                startContainer: selectedTextObj.range.startContainer,
                startOffset: selectedTextObj.range.startOffset,
                endContainer: selectedTextObj.range.endContainer,
                endOffset: selectedTextObj.range.endOffset
            });
        });
        $('#btnCancelColor').on('click', () => $(colorPickerDlgId).addClass('hidden'));
        $('#btnClearColor').on('click', () => {
            clearSelectedColor();
            $(colorPickerDlgId).addClass('hidden');
        });
        $('#btnPickColor').on('click', () => {
            colorOnClick({ color: $('#hexColor').val() });
            $(colorPickerDlgId).addClass('hidden');
        });
    }
};



const italicOnClick = (params) => {
    setSelectionAndCursor();
    document.execCommand('italic');
    isItalic = !isItalic;
    toggleActiveBtnStatus({ id: btnItalicId, isActive: isItalic });
    consolidateTextNodes();
};

const showActiveFormatBtns = () => {
    const sel = getSelection();
    let node = sel.isCollapsed ? sel.anchorNode : sel.focusNode;
    isBold = false;
    isItalic = false;
    isUnderline = false;
    while (node !== null) {
        setFlagsForToolBar({ node: node });
        node = node.parentNode;
    }
    setBtnsForToolBar();
    setColorBtnIcon();
};

const textAlignOnClick = (params) => {
    document.execCommand(params.cmd, false, null);
    if (params.cmd === 'justifyCenter') {
        isAlignLeft = false;
        isAlignCenter = true;
        isAlignRight = false;
    } else if (params.cmd === 'justifyRight') {
        isAlignLeft = false;
        isAlignCenter = false;
        isAlignRight = true;
    } else {
        isAlignLeft = true;
        isAlignCenter = false;
        isAlignRight = false;
    }
    toggleAlignment();
};

const underlineOnClick = (params) => {
    setSelectionAndCursor();
    document.execCommand('underline');
    isUnderline = !isUnderline;
    toggleActiveBtnStatus({ id: btnUnderlineId, isActive: isUnderline });
    consolidateTextNodes();
};

export {
    bgColorOnClick,
    boldOnClick,
    colorOnClick,
    convertATagsToSpans,
    convertSpansToATags,
    init_ctssEditor,
    italicOnClick,
    showActiveFormatBtns,
    textAlignOnClick,
    underlineOnClick
};